import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { PAGE_OWNER_ATTR, usePageOwner } from "../../lib/navigation/pageOwner";

/**
 * Portal com a marca da tela dona (BUG-331) — ver `lib/navigation/pageOwner.ts`.
 * Use pela função `ownedPortal`, que tem a assinatura do `createPortal`.
 */
export function OwnedPortal({
  children,
  container,
}: {
  children: ReactNode;
  container: Element | DocumentFragment;
}) {
  const owner = usePageOwner();
  if (owner === null) return createPortal(children, container);
  // `display: contents`: o invólucro não cria caixa, então `fixed`, `inset-0`
  // e os seletores de descendente do diálogo de desktop seguem iguais.
  return createPortal(
    <div {...{ [PAGE_OWNER_ATTR]: owner }} className="contents">
      {children}
    </div>,
    container,
  );
}
